import appBackupplans from "../../views/appPlans/backups.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "backupplans";
  const params = ["page", "limit"];

  $stateProvider.state("backupplans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBackupplans,
      },
    },
    reloadOnSearch: false,
    data: { title: "Backupplans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/backupplans/backupplans.urls.js